// extracted by mini-css-extract-plugin
export default {"typingContainer":"TypingEffect_typingContainer__GRwmT","cursor":"TypingEffect_cursor__32MhU","typing":"TypingEffect_typing__q-z4Y","blinking":"TypingEffect_blinking__MR98n"};